import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type UseApprenticeApplicationPathParams = {
  userId: number;
};

const { useGet: useApprenticeApplicationPath } = getCRUDHooks({
  entityName: 'apprenticeApplicationPaths',
  get: ({ userId }: UseApprenticeApplicationPathParams) =>
    clientApi.getOCClient().helpers.user.users.id(userId).apprenticeApplicationPaths.find(),
});

// eslint-disable-next-line import/prefer-default-export
export { useApprenticeApplicationPath };
